import { render, staticRenderFns } from "./secondaryPagesLXWM.vue?vue&type=template&id=0fc57e69&scoped=true&"
import script from "./secondaryPagesLXWM.vue?vue&type=script&lang=js&"
export * from "./secondaryPagesLXWM.vue?vue&type=script&lang=js&"
import style0 from "./secondaryPagesLXWM.vue?vue&type=style&index=0&id=0fc57e69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc57e69",
  null
  
)

export default component.exports